<template>
  <transition name="fade" mode="out-in">
    <div
      v-if="modal"
      role="dialog"
      :aria-hidden="!modal"
      class="p-4 w-full h-full fixed inset-0 z-[9999999] flex flex-col items-start bg-overlay overflow-auto"
      @click.self="hide"
    >
      <!-- m-auto to center the modal on the screen, vertically and horizontally -->
      <div
        aria-label="card"
        :class="[
          maxWidth,
          'px-3.75 pb-3.75 mb:pb-8 md:px-16 m-auto w-full bg-white rounded-[10px] shadow-small-grey cursor-auto overflow-auto'
        ]"
      >
        <div
          class="pt-8 pb-1 md:px-3.75 sticky top-0 bg-white z-50 rounded-t-lg"
        >
          <div class="flex flex-row justify-between gap-6 items-start">
            <div class="p-2"></div>
            <h3
              aria-label="title"
              class="text-center flex-grow tg-serif-header-4 text-grey-5"
            >
              {{ title }}
            </h3>
            <button
              type="button"
              aria-label="close"
              :title="$t('close')"
              class="px-2 py-1 text-xl rounded-full"
              @click="hide"
            >
              <font-awesome-icon :icon="['far', 'times']" />
            </button>
          </div>
          <slot name="sticky-heading"></slot>
        </div>
        <div aria-label="content" class="p-4">
          <slot :confirm="confirm" :cancel="cancel">
            <p>This is the default modal content.</p>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    title: {
      type: String,
      default: 'Title'
    },
    maxWidth: {
      type: String,
      default: 'max-w-xl'
    }
  },
  data() {
    return {
      // Controls the visibility of the modal.
      modal: false,
      // Holds the resolve function for the promise returned by show().
      resolvePromise: null
    };
  },
  methods: {
    /**
     * Shows the modal and returns a promise that resolves when the modal is closed.
     * The promise resolves with `true` if confirmed, and `false` otherwise.
     */
    show() {
      this.modal = true;
      this.$emit('show');
      return new Promise(resolve => {
        this.resolvePromise = resolve;
      });
    },
    /**
     * Hides the modal and resolves the promise with `false`.
     */
    hide() {
      this.modal = false;
      this.$emit('hide');
      this.resolvePromise(false);
    },
    /**
     * Confirms the modal action and resolves the promise with `true`.
     */
    confirm() {
      this.modal = false;
      this.$emit('hide');
      this.resolvePromise(true);
    },
    /**
     * Cancels the modal action and resolves the promise with `false`.
     */
    cancel() {
      this.hide();
    }
  }
};
</script>
